import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useMaxItemPopupStyles = makeStyles({
    buttonContainer: {
        marginLeft: 'auto',
        width: '75%',
        '@media screen and (max-width: 480px)': {
            ...shorthands.margin('0', 'auto')
        }
    },
    button: {
        ...shorthands.margin('0', tokens.spacingHorizontalL),
        '@media screen and (max-width: 480px)': {
            ...shorthands.margin(tokens.spacingVerticalM, '0')
        }
    }
});
